import accountHttp from './accountHttp';

const getUserAccount = (context) => {
  return new Promise((resolve, reject) => {
    accountHttp.getAuthorities(context).then(response => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default {
  getUserAccount
};



// WEBPACK FOOTER //
// ./src/api/account/index.js